<template>
  <div class="previewBox">
    <div style="width: 100%; display: flex; height: 21px; user-select: none">
      <c-label
        inline
        :color="$theme.COLOR.UI.UI13"
        :weight="500"
        style="display: flex; margin-right: auto; font-size: 16px; line-height: 16px"
        >{{ this.$util.capitalize($t('label.preview')) }}</c-label
      >

      <lego-segment-wrapper
        v-if="chartTypeShow"
        :checked="chartType"
        @update:modelValue="chartSelected"
        style="display: flex; margin-left: auto"
      >
        <lego-segment-button value="line" class="lego-segment-button-fill">
          <lego-icon iconType="line" icon="line_chart" :iconSize="16" />
        </lego-segment-button>
        <lego-segment-button value="stack">
          <lego-icon iconType="line" icon="stack_chart" :iconSize="16" />
        </lego-segment-button>
        <lego-segment-button value="bar">
          <lego-icon iconType="line" icon="bar_chart2" :iconSize="16" />
        </lego-segment-button>
        <lego-segment-button value="scatter">
          <lego-icon iconType="line" icon="scatter_chart" :iconSize="16" />
        </lego-segment-button>
      </lego-segment-wrapper>
    </div>
    <c-scroll
      style="
        margin-top: 16px;
        max-height: 680px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        text-align: center;
      "
    >
      <div style="display: flex; justify-content: center; align-items: center">
        <div style="display: flex; flex-direction: column; min-width: 183px" :style="previewStyle">
          <div
            :style="
              'display: grid; width: ' +
              (mainConfig && typeof mainConfig.w == 'string' ? width : width + 20 + 'px;') +
              'text-align: center;padding-right:20px'
            "
          >
            <div
              v-for="(config, index) in configItems"
              :key="config.chartId + index"
              class="preview-box-content"
              style="display: inline-block; background-color: #fff; margin-bottom: 10px"
              :style="{
                width: width,
                height: height,
                outline: widgetName !== 'StatusMetricWidget' ? '1px solid #ccc' : 'unset'
              }"
            >
              <component
                :is="widgetName"
                :excludeResources="excludeResources"
                :configItem="config"
                :configIndex="index"
                :searchDate="searchDate"
                @onConfigChange="onConfigChange"
                :isSettingMode="true"
                :isCustomDashboard="true"
              />
            </div>
          </div>
        </div>
      </div>
    </c-scroll>
  </div>
</template>
<script>
import TitleBoxWidget from './components/TitleBoxWidget';
import EventStausWidget from './components/EventStausWidget';
import MonitoringStatusWidget from './components/MonitoringStatusWidget';
import PerfermanceTop5Widget from './components/PerfermanceTop5Widget';
import EventMapWidget from './components/EventMapWidget';
import EventHistoryWidget from './components/EventHistoryWidget';
import TimeSeriesGraphWidget from './components/TimeSeriesGraphWidget';
import StatusMetricWidget from './components/StatusMetricWidget';
import InstanceMapWidget from './components/InstanceMapWidget';
import { GLOBAL_CDN } from '@/containers/utils/constant';

export default {
  components: {
    TitleBoxWidget,
    EventStausWidget,
    MonitoringStatusWidget,
    PerfermanceTop5Widget,
    EventMapWidget,
    EventHistoryWidget,
    TimeSeriesGraphWidget,
    StatusMetricWidget,
    InstanceMapWidget
  },
  emits: ['configModify'],
  props: {
    // 위젯 ID
    widgetName: {
      type: String,
      default: null
    },
    // 위젯 설정 정보
    configItems: {
      type: Array,
      default: () => []
    },
    // dashboard 검색시간
    searchDate: {
      type: Object
    }
  },
  watch: {
    widgetName: {
      deep: true,
      handler() {}
    },
    configItems: {
      deep: true,
      handler() {
        if (this.configItems && this.configItems.length > 0) {
          this.mainConfig = this.configItems[0].chartAttr;
        }
      }
    }
  },
  data() {
    return {
      //items: [],
      chartType: 'line', // chart Type : line, stack, bar, scatter
      mainConfig: null, // 위젯 속성 정보
      isChanged: false,
      excludeResources: [GLOBAL_CDN]
    };
  },
  created() {
    if (this.configItems && this.configItems.length > 0) {
      this.mainConfig = this.configItems[0].chartAttr;
      this.chartType = this.mainConfig.widget.options.chartType;
    }
  },
  computed: {
    // 시계열 그래프 위젯만 chart type 보여줌
    chartTypeShow() {
      if (this.mainConfig && this.mainConfig.widget) {
        return this.mainConfig.widget.type === 'TimeSeriesGraphWidget';
      } else return false;
    },
    // 위젯 가로 크기
    width() {
      if (this.mainConfig && this.mainConfig.w) {
        if (typeof this.mainConfig.w == 'string') {
          return this.mainConfig.w;
        }
        return this.mainConfig.w * 183 + 'px';
      }
      return 366 + 'px';
    },
    // 위젯 세로 크기
    height() {
      if (this.mainConfig && this.mainConfig.h) {
        return this.mainConfig.h * 135 + (this.mainConfig.h - 1) * 24 + 'px';
      }
      return 286 + 'px';
    },
    // 미리보기 style
    previewStyle() {
      return 'min-height: 486px;justify-content: center; margin: 20px 0';
    }
  },

  mounted() {},
  methods: {
    // 차트 선택
    chartSelected(value) {
      if (value !== this.chartType) {
        this.chartType = value;
        this.isChanged = true;
        let configs = this.$util.deepCopy(this.configItems);
        configs[0].chartAttr.widget.options.chartType = this.chartType;
        configs[0].isApiCall = true;
        this.$emit('configModify', configs);
      }
    },
    onChange() {},

    // 위젯 설정 정보 update Event;
    onConfigChange(item) {
      let configs = this.$util.deepCopy(this.configItems);
      configs[item.index] = item.config;
      this.$emit('configModify', configs);
    }
  }
};
</script>
<style lang="scss" scoped>
:deep .lego-segment-button--medium {
  min-width: 32px !important;
  width: 32px !important;
}

:deep .lego-segment-button-fill {
  .lego-icon {
    svg {
      g {
        path {
          fill: none;
        }
      }
    }
  }
}

:deep .lego-tooltip-wrapper .lego-tooltip.lego-tooltip--with-close {
  text-align: left;
}
</style>
